import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { DeliverySite_GetCompanies_Basic, DeliverySite_GetMiddleLeaderDetails, DeliverySite_GetMiddleLeaders, DeliverySite_GetTopLeaders_Basic, DeliverySite_InsertEditMiddleLeader } from '../../../Services/Actions';
import Select from 'react-select';
import Popover from 'react-popover';

import * as styles from './styles';

import ButtonGroup from '../../../Components/Buttons/ButtonGroup';
import Loading from '../../../Components/Loading';
import MultiText from '../../../Components/Text/MultiText';
import PageText from '../../../Components/Text/PageText';
import PaginationContainer from '../../../Components/PaginationCounter';
import ProfilePhoto from '../../../Components/ProfilePhoto';
import Spacer from '../../../Components/Spacer';

import Info from '../../../Modals/Info';

import DownArrow from '../../../Assets/Icons/DownArrow.png';
import InfoIcon from '../../../Assets/Icons/Info.png';
import Plus from '../../../Assets/Icons/PlusSign_White.png';
import UpArrow from '../../../Assets/Icons/UpArrow.png';

import { emailValidator } from '../../../Functions';

const MIDDLE_LEADER_TABLE_COLUMNS = [
    { Id: 1, SortCol: null, Title: 'User Id' },
    { Id: 2, SortCol: 'DisplayName', Title: 'Name' },
    { Id: 3, SortCol: null, Title: 'Top Leader' }
];

const customStyles = {
    valueContainer: (provided, state) => ({
        ...provided,
        textOverflow: "ellipsis",
        maxWidth: "90%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        display: "initial"
    }),
    input: (provided, state) => ({
        ...provided,
        minWidth: '20%'
    })
}

class MiddleLeadersComponent extends React.Component {
    TimeoutId = null;

    state = {
        DisplayName_Previous: '',
        DisplayName: '',
        MiddleLeaders: [],
        IsMoreResults: null,
        PageNo: 1,
        PageSize: 10,
        Sorting: {
            SortCol: 'DisplayName',
            SortDir: 'ASC'
        },
        TotalRecords: null,

        Filters: {
            Companies: {
                Companies: [],
                IsLoading: false,
                Loaded: false,
                Selected: []
            },
            TopLeaders: {
                IsLoading: false,
                Loaded: false,
                Selected: [],
                Users: []
            }
        },

        PopoverIsOpen_Companies: false,
        PopoverIsOpen_TopLeaders: false,
        PopoverIsOpen_Users: false,

        ShowAddMiddleLeaderModal: false,
        ShowAddMiddleLeaderModal_MiddleLeaderEmail: '',
        ShowAddMiddleLeaderModal_TopLeader_UserId: null,
        ShowAddMiddleLeaderModal_Loading: false,

        ShowMiddleLeaderDetailModal: false,
        ShowMiddleLeaderDetailModal_Data: {},
        ShowMiddleLeaderDetailModal_Loading: false
    }

    componentDidMount() {
        this.onLoadMiddleLeaders();
    }

    onAddMiddleLeader = () => {
        var { ShowAddMiddleLeaderModal_MiddleLeaderEmail: Email, ShowAddMiddleLeaderModal_TopLeader_UserId: TopLeader_UserId } = this.state;

        this.setState({ ShowAddMiddleLeaderModal_Loading: true }, () => {
            this.props.DeliverySite_InsertEditMiddleLeader({ Email, TopLeader_UserId }).then(() => {
                this.onToggleShowAddMiddleLeaderModal({ ShowAddMiddleLeaderModal: false });
                this.onLoadMiddleLeaders();
            })
        })
    }

    onBlurFilter_Companies = () => {
        this.setState({ PageNo: 1 }, () => this.onLoadMiddleLeaders());
    }

    onBlurFilter_TopLeaders = () => {
        this.setState({ PageNo: 1 }, () => this.onLoadMiddleLeaders());
    }

    onBlurSearchMiddleLeaders = () => {
        var { DisplayName, DisplayName_Previous } = this.state;

        if (DisplayName !== DisplayName_Previous) {
            this.setState({ DisplayName_Previous: DisplayName, PageNo: 1 }, () => this.onLoadMiddleLeaders());
        }
    }

    onChangeAddLeaderModal_MiddleLeaderEmail = event => {
        this.setState({ ShowAddMiddleLeaderModal_MiddleLeaderEmail: event.target.value });
    }

    onChangeAddLeaderModal_TopLeader = data => {
        this.setState({ ShowAddMiddleLeaderModal_TopLeader_UserId: data.UserId });
    }

    onChangeMiddleLeaderSearch = event => {
        this.setState({ DisplayName: event.target.value });
    }

    onChangeFilter_Companies = data => {
        if (!data) data = [];
        
        var Filters = { ...this.state.Filters };
        Filters.Companies.Selected = data;

        this.setState({ Filters });
    }

    onChangeFilter_TopLeaders = data => {
        if (!data) data = [];
        
        var Filters = { ...this.state.Filters };
        Filters.TopLeaders.Selected = data;

        this.setState({ Filters });
    }

    onFocusFilter_Companies = () => {
        if (!this.state.Filters.Companies.Loaded) {
            var Filters = { ...this.state.Filters };
            Filters.Companies = { ...Filters.Companies };
            Filters.Companies.IsLoading = true;

            this.setState({ Filters }, () => {
                this.props.DeliverySite_GetCompanies_Basic({}).then(({ Companies }) => {
                    Filters.Companies.IsLoading = false;
                    Filters.Companies.Companies = Companies;
                    Filters.Companies.Loaded = true;
                    this.setState({ Filters });
                });
            });
        }
    }

    onFocusFilter_TopLeaders = () => {
        if (!this.state.Filters.TopLeaders.Loaded) {
            var Filters = { ...this.state.Filters };
            Filters.TopLeaders = { ...Filters.TopLeaders };
            Filters.TopLeaders.IsLoading = true;

            this.setState({ Filters }, () => {
                this.props.DeliverySite_GetTopLeaders_Basic().then(({ Users }) => {
                    Filters.TopLeaders.IsLoading = false;
                    Filters.TopLeaders.Users = Users;
                    Filters.TopLeaders.Loaded = true;
                    this.setState({ Filters });
                });
            });
        }
    }

    onLoadMiddleLeaders = Increment => {
        var { DisplayName, Filters: { Companies, TopLeaders }, PageNo, PageSize, Sorting: { SortCol, SortDir } } = this.state;

        var CompanyIds = Companies.Selected.length > 0 ? Companies.Selected.map(({ CompanyId }) => CompanyId).join(',') : null;
        var TopLeader_UserIds = TopLeaders.Selected.length > 0 ? TopLeaders.Selected.map(({ UserId }) => UserId).join(',') : null;

        if (Increment) PageNo++;

        this.props.DeliverySite_GetMiddleLeaders({ CompanyIds, MiddleLeaderName: DisplayName, PageNo, PageSize, SortCol, SortDir, TopLeader_UserIds }).then(({ MiddleLeaders, IsMoreResults, TotalRecords }) => {
            this.setState({ MiddleLeaders, IsMoreResults, TotalRecords });
        });
    }

    onPaginate = ({ NewPageNo }) => {
        if (this.statePageNo !== NewPageNo) this.setState({ PageNo: NewPageNo }, () => this.onLoadMiddleLeaders());
    }

    onTogglePopover = PopoverType => {
        this.setState({ [PopoverType]: !this.state[PopoverType] }, () => {
            if (!this.state[PopoverType] && !!this.TimeoutId) clearTimeout(this.TimeoutId);
        });
    }

    onToggleShowAddMiddleLeaderModal = ({ ShowAddMiddleLeaderModal }) => {
        if (!ShowAddMiddleLeaderModal) this.setState({ ShowAddMiddleLeaderModal, ShowAddMiddleLeaderModal_MiddleLeaderEmail: '', ShowAddMiddleLeaderModal_TopLeader_UserId: null, ShowAddMiddleLeaderModal_Loading: false });
        else this.setState({ ShowAddMiddleLeaderModal });
    }

    onToggleShowMiddleLeaderDetailModal = ({ MiddleLeader_UserId, ShowMiddleLeaderDetailModal }) => {
        if (!ShowMiddleLeaderDetailModal) this.setState({ ShowMiddleLeaderDetailModal, ShowMiddleLeaderDetailModal_Loading: false });
        else {
            this.setState({ ShowMiddleLeaderDetailModal, ShowMiddleLeaderDetailModal_Loading: true }, () => {
                this.props.DeliverySite_GetMiddleLeaderDetails({ MiddleLeader_UserId }).then(({ UserDetails }) => {
                    this.setState({ ShowMiddleLeaderDetailModal_Data: UserDetails, ShowMiddleLeaderDetailModal_Loading: false });
                })
            });
        }
    }

    onToggleSorting = ({ SortCol: NewSortCol }) => {
        var { SortCol, SortDir } = this.state.Sorting;

        // SortDir Goes From ASC --> DESC --> Nothing

        // Toggle Sorting Of Already Sorted Column
            if (SortCol === NewSortCol) {
                if (SortDir === 'ASC') SortDir = 'DESC';
                else if (SortDir === 'DESC') {
                    SortDir = '';
                    SortCol = '';
                }
                else if (SortDir === '') SortDir = 'ASC';
            }
        // Start Sorting On New Column
            else {
                SortCol = NewSortCol;
                SortDir = 'ASC';
            }

        this.setState({ PageNo: 1, Sorting: { SortCol, SortDir } }, () => this.onLoadMiddleLeaders());
    }

    renderAddMiddleLeaderModal = () => {
        var { t } = this.props;
        var { ShowAddMiddleLeaderModal, ShowAddMiddleLeaderModal_MiddleLeaderEmail, ShowAddMiddleLeaderModal_TopLeader_UserId, ShowAddMiddleLeaderModal_Loading } = this.state;

        if (ShowAddMiddleLeaderModal) {
            return (
                <Info
                    BottomButton="submit"
                    BottomButtonOnClick={this.onAddMiddleLeader}
                    BottomButtonDisabled={!ShowAddMiddleLeaderModal_MiddleLeaderEmail || !emailValidator(ShowAddMiddleLeaderModal_MiddleLeaderEmail) || !ShowAddMiddleLeaderModal_TopLeader_UserId}
                    BottomButtonText={t('_save')}
                    InformationRenderer={this.renderAddMiddleLeaderModal_Information}
                    Loading={(ShowAddMiddleLeaderModal_Loading)}
                    OnHide={() => this.onToggleShowAddMiddleLeaderModal({ ShowAddMiddleLeaderModal: false })}
                    Show={ShowAddMiddleLeaderModal}
                />
            );
        }
    }

    renderAddMiddleLeaderModal_Information = () => {
        var { Filters: { TopLeaders }, ShowAddMiddleLeaderModal_MiddleLeaderEmail } = this.state;

        return (
            <styles.InsertEditModalContainer className="InsertEditModalContainer">
                <PageText FontFamily="medium" FontSize="medium-3" JustifyContent="center" NoMargin Text="Add Middle Leader" TextAlign="center" />

                <Spacer Size="extra-small" />

                <styles.SearchInput
                    AutoFocus
                    FontSize="medium-1"
                    NoLabel
                    NoMargin
                    OnChange={this.onChangeAddLeaderModal_MiddleLeaderEmail}
                    Placeholder="Middle leader email"
                    Size="medium"
                    Type="text"
                    Value={ShowAddMiddleLeaderModal_MiddleLeaderEmail}
                />

                <Spacer Size="medium" />

                <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="center" NoMargin Text="Choose top leader" TextAlign="center" />

                <Select
                    closeMenuOnSelect={false}
                    getOptionLabel={option => option.DisplayName}
                    getOptionValue={option => option.UserId}
                    isLoading={TopLeaders.IsLoading}
                    isMulti={false}
                    // components={{ ValueContainer }}
                    hideSelectedOptions={true}
                    isSearchable
                    onChange={this.onChangeAddLeaderModal_TopLeader}
                    onFocus={this.onFocusFilter_TopLeaders}
                    options={TopLeaders.Users}
                    placeholder="Top Leaders"
                    styles={customStyles}
                    menuPosition="fixed"
                />
            </styles.InsertEditModalContainer>
        );
    }

    renderMiddleLeaders = () => {
        var { MiddleLeaders, PageNo, PageSize, Sorting: { SortCol: StateSortCol, SortDir: StateSortDir }, TotalRecords } = this.state;

        return (
            <styles.BodyContainer className="BodyContainer">
                <styles.BodyHeader className="BodyHeader">
                    <PageText FontFamily="medium" FontSize="large" JustifyContent="flex-start" NoMargin Text="Middle Leaders" TextAlign="left" />

                    <styles.BodyHeaderRight className="BodyHeaderRight">
                        <ButtonGroup
                            Buttons={[{ BackgroundGradient: "gradient1", Border: 'none', Color: 'white', ColorHover: 'white', Icon: Plus, IconPosition: 'left', IconSize: { Height: '20px', Width: '20px' }, OnClick: () => this.onToggleShowAddMiddleLeaderModal({ ShowAddMiddleLeaderModal: true }), Title: "New Middle Leader" }]}
                            ButtonWidth="fit-content"
                            ContainerWidth="fit-content"
                            JustifyContent="center"
                        />
                    </styles.BodyHeaderRight>
                </styles.BodyHeader>

                <Spacer Size="small" />

                {this.renderViewCount()}

                {
                    TotalRecords > 0 &&
                    <>
                        <Spacer Size="small" />

                        {
                            (PageNo !== 1 || PageSize < TotalRecords) &&
                            <>
                                <PaginationContainer OnPaginate={this.onPaginate} PageNo={PageNo} PageSize={PageSize} TotalRecords={TotalRecords} />
        
                                <Spacer Size="medium" />
                            </>
                        }

                        <styles.UsersContainer className="UsersContainer">
                            <styles.UsersTableContainer className="UsersTableContainer">
                                <styles.UsersTable className="UsersTable">
                                    <styles.UsersTableHeader className="UsersTableHeader">
                                        <styles.UsersTableHeaderRow className="UsersTableHeaderRow">
                                            {
                                                MIDDLE_LEADER_TABLE_COLUMNS.map(({ Id, SortCol, Title }) => {
                                                    return (
                                                        <styles.UsersTableHeaderCell className="UsersTableHeaderCell" key={Id} onClick={SortCol ? () => this.onToggleSorting({ SortCol }) : null}>
                                                            <styles.UsersTableHeaderCellInnerDiv className="UsersTableHeaderCellInnerDiv">
                                                                <PageText FontFamily="semibold" FontSize="small" JustifyContent="flex-start" NoMargin TextAlign="left" Text={Title} />
                                                                {SortCol ? StateSortCol === SortCol && <styles.SortingIcon ImageSrc={StateSortDir === 'DESC' ? DownArrow : UpArrow} /> : null}
                                                            </styles.UsersTableHeaderCellInnerDiv>
                                                        </styles.UsersTableHeaderCell>
                                                    );
                                                })
                                            }
                                        </styles.UsersTableHeaderRow>
                                    </styles.UsersTableHeader>
                                    <styles.UsersTableBody className="UsersTableBody">
                                        {
                                            MiddleLeaders.map((User, UserIndex) => {
                                                var {
                                                    DisplayName, ProfilePhotoUrl, Sex, UserId,
                                                    TopLeader_DisplayName, TopLeader_ProfilePhotoUrl, TopLeader_Sex
                                                } = User;

                                                return (
                                                    <styles.UsersTableBodyRow className="UsersTableBodyRow" key={UserId}>
                                                        <styles.UsersTableBodyCell className="UsersTableBodyCell">
                                                            {UserId}
                                                        </styles.UsersTableBodyCell>
                                                        <styles.UsersTableBodyCell className="UsersTableBodyCell" onClick={() => this.onToggleShowMiddleLeaderDetailModal({ MiddleLeader_UserId: UserId, ShowMiddleLeaderDetailModal: true })}>
                                                            <styles.UsersTableBodyCellFlexed className="UsersTableBodyCellFlexed">
                                                                <styles.ProfilePhotoContainer className="ProfilePhotoContainer">
                                                                    <ProfilePhoto Sex={Sex || 'Male'} Size="small-3" Source={ProfilePhotoUrl || ''} />
                                                                </styles.ProfilePhotoContainer>
                                                                {DisplayName}
                                                            </styles.UsersTableBodyCellFlexed>
                                                        </styles.UsersTableBodyCell>
                                                        <styles.UsersTableBodyCell className="UsersTableBodyCell">
                                                            <styles.UsersTableBodyCellFlexed className="UsersTableBodyCellFlexed">
                                                                <styles.ProfilePhotoContainer className="ProfilePhotoContainer">
                                                                    <ProfilePhoto Sex={TopLeader_Sex || 'Male'} Size="small-3" Source={TopLeader_ProfilePhotoUrl || ''} />
                                                                </styles.ProfilePhotoContainer>
                                                                {TopLeader_DisplayName}
                                                            </styles.UsersTableBodyCellFlexed>
                                                        </styles.UsersTableBodyCell>
                                                    </styles.UsersTableBodyRow>
                                                )
                                            })
                                        }
                                    </styles.UsersTableBody>
                                </styles.UsersTable>
                            </styles.UsersTableContainer>
                        </styles.UsersContainer>
                    </>
                }
            </styles.BodyContainer>
        );
    }

    renderFilters = () => {
        var { t } = this.props;

        const popoverProps_Companies = {
            isOpen: this.state.PopoverIsOpen_Companies,
            preferPlace: 'below',
            onOuterAction: () => this.onTogglePopover('PopoverIsOpen_Companies'),
            body: this.renderPopoverContent('Companies'),
            tipSize: 0.01
        }

        const popoverProps_TopLeaders = {
            isOpen: this.state.PopoverIsOpen_TopLeaders,
            preferPlace: 'below',
            onOuterAction: () => this.onTogglePopover('PopoverIsOpen_TopLeaders'),
            body: this.renderPopoverContent('TopLeaders'),
            tipSize: 0.01
        }

        const popoverProps_Users = {
            isOpen: this.state.PopoverIsOpen_Users,
            preferPlace: 'below',
            onOuterAction: () => this.onTogglePopover('PopoverIsOpen_Users'),
            body: this.renderPopoverContent('Users'),
            tipSize: 0.01
        }

        var { DisplayName, Filters: { Companies, TopLeaders }} = this.state;

        return (
            <styles.FiltersContainer className="FiltersContainer">
                <PageText FontFamily="bold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text="Filters" TextAlign="left" />

                <Spacer Size="extra-small" />

                <styles.FiltersSubContainer className="FiltersSubContainer">
                    <styles.FilterContainer className="FilterContainer">
                        <styles.FilterHeaderContainer className="FilterHeaderContainer">
                            <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin TextAlign="left" Text="Search Middle Leaders" />

                            <Popover {...popoverProps_Users}>
                                <styles.MaxPercentInfoIcon ImageSrc={InfoIcon} OnMouseEnter={() => this.onTogglePopover('PopoverIsOpen_Users')} OnMouseLeave={() => this.onTogglePopover('PopoverIsOpen_Users')} />
                            </Popover>
                        </styles.FilterHeaderContainer>

                        <Spacer Size="extra-extra-small" />

                        <styles.SearchUsersInput
                            FontSize="medium-1"
                            NoLabel
                            NoMargin
                            OnBlur={this.onBlurSearchMiddleLeaders}
                            OnChange={this.onChangeMiddleLeaderSearch}
                            Placeholder={t('_search')}
                            Size="medium"
                            Type="text"
                            Value={DisplayName}
                        />
                    </styles.FilterContainer>

                    <styles.FilterContainer className="FilterContainer">
                        <styles.FilterHeaderContainer className="FilterHeaderContainer">
                            <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin TextAlign="left" Text="Companies" />

                            <Popover {...popoverProps_Companies}>
                                <styles.MaxPercentInfoIcon ImageSrc={InfoIcon} OnMouseEnter={() => this.onTogglePopover('PopoverIsOpen_Companies')} OnMouseLeave={() => this.onTogglePopover('PopoverIsOpen_Companies')} />
                            </Popover>
                        </styles.FilterHeaderContainer>

                        <Spacer Size="extra-extra-small" />

                        <Select
                            closeMenuOnSelect={false}
                            getOptionLabel={option => option.CompanyName}
                            getOptionValue={option => option.CompanyId}
                            isLoading={Companies.IsLoading}
                            isMulti
                            // components={{ ValueContainer }}
                            hideSelectedOptions={true}
                            isSearchable
                            onBlur={this.onBlurFilter_Companies}
                            onChange={data => this.onChangeFilter_Companies(data)}
                            onFocus={this.onFocusFilter_Companies}
                            options={Companies.Companies}
                            placeholder={t('Filter by Company')}
                            styles={customStyles}
                            menuPosition="fixed"
                        />
                    </styles.FilterContainer>

                    <styles.FilterContainer className="FilterContainer">
                        <styles.FilterHeaderContainer className="FilterHeaderContainer">
                            <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin TextAlign="left" Text="Top Leaders" />

                            <Popover {...popoverProps_TopLeaders}>
                                <styles.MaxPercentInfoIcon ImageSrc={InfoIcon} OnMouseEnter={() => this.onTogglePopover('PopoverIsOpen_TopLeaders')} OnMouseLeave={() => this.onTogglePopover('PopoverIsOpen_TopLeaders')} />
                            </Popover>
                        </styles.FilterHeaderContainer>

                        <Spacer Size="extra-extra-small" />

                        <Select
                            closeMenuOnSelect={false}
                            defaultValue={[]}
                            getOptionLabel={option => option.DisplayName}
                            getOptionValue={option => option.UserId}
                            isLoading={TopLeaders.IsLoading}
                            isMulti
                            // components={{ ValueContainer }}
                            hideSelectedOptions={false}
                            isSearchable
                            onBlur={this.onBlurFilter_TopLeaders}
                            onChange={data => this.onChangeFilter_TopLeaders(data)}
                            onFocus={this.onFocusFilter_TopLeaders}
                            options={TopLeaders.Users}
                            placeholder={t('Filter by Top Leader')}
                            styles={customStyles}
                            menuPosition="fixed"
                        />
                    </styles.FilterContainer>
                </styles.FiltersSubContainer>
            </styles.FiltersContainer>
        );
    }

    renderPopoverContent = ContentType => {
        // var { t } = this.props;

        return (
            <styles.PopoverContent className="PopoverContent">
                {ContentType === 'Companies' && <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent="center" NoMargin Text="Shows Middle Leaders who have leaders who have DHCs who have ACTIVE orders with employees in the selected companies" TextAlign="center" />}
                {ContentType === 'TopLeaders' && <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent="center" NoMargin Text="Shows all Middle Leaders who have a top leader in the selected top top leaders" TextAlign="center" />}
                {ContentType === 'Users' && <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent="center" NoMargin Text="Search by first name, last name, full name or email address of the Middle Leader" TextAlign="center" />}
            </styles.PopoverContent>
        );
    }

    renderShowMiddleLeaderDetailModal = () => {
        // var { t } = this.props;
        var { ShowMiddleLeaderDetailModal, ShowMiddleLeaderDetailModal_Loading } = this.state;

        if (ShowMiddleLeaderDetailModal) {
            return (
                <Info
                    BottomButton="cancel"
                    InformationRenderer={this.renderShowMiddleLeaderDetailModal_Information}
                    Loading={ShowMiddleLeaderDetailModal_Loading}
                    OnHide={() => this.onToggleShowMiddleLeaderDetailModal({ ShowMiddleLeaderDetailModal: false })}
                    Show={ShowMiddleLeaderDetailModal}
                    Size="small"
                />
            );
        }
    }

    renderShowMiddleLeaderDetailModal_Information = () => {
        var { ShowMiddleLeaderDetailModal_Data: UserDetails } = this.state;

        if (!UserDetails || Object.keys(UserDetails).length === 0) return null;

        var { DisplayName, DOB, Email, PhoneNumber, ProfilePhotoUrl, Sex } = UserDetails;

        return (
            <styles.DHCDetailModalInfoContainer className="DHCDetailModalInfoContainer">
                <styles.ProfilePhotoContainer_Popup className="ProfilePhotoContainer_Popup">
                    <ProfilePhoto Sex={Sex || 'Male'} Size="extra-large" Source={ProfilePhotoUrl || ''} />
                </styles.ProfilePhotoContainer_Popup>

                <Spacer Size="extra-small" />

                <PageText FontFamily="semibold" FontSize="medium-3" JustifyContent="flex-start" NoMargin TextAlign="left" Text={DisplayName} />
                <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent="flex-start" NoMargin TextAlign="left" Text={Email} />

                {
                    PhoneNumber &&
                    <>
                        <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent="flex-start" NoMargin TextAlign="left" Text={PhoneNumber} />
                    </>
                }

                <styles.StyledHR />

                <styles.DHCDetailModalInfoFlexContainer className="DHCDetailModalInfoFlexContainer">
                    <MultiText
                        Texts={[
                            { FontColor: 'black', FontFamily: 'semibold-italic', FontSize: 'medium-1', Text: 'Sex:' },
                            { FontColor: 'black', FontFamily: 'medium-italic', FontSize: 'medium-1', Text: Sex }
                        ]}
                    />
                </styles.DHCDetailModalInfoFlexContainer>
                <styles.DHCDetailModalInfoFlexContainer className="DHCDetailModalInfoFlexContainer">
                    <MultiText
                        Texts={[
                            { FontColor: 'black', FontFamily: 'semibold-italic', FontSize: 'medium-1', Text: 'Birthday:' },
                            { FontColor: 'black', FontFamily: 'medium-italic', FontSize: 'medium-1', Text: DOB }
                        ]}
                    />
                </styles.DHCDetailModalInfoFlexContainer>
            </styles.DHCDetailModalInfoContainer>
        )
    }

    renderViewCount = () => {
        var { t } = this.props;

        var { PageNo, PageSize, TotalRecords } = this.state;

        if (!TotalRecords) TotalRecords = 0;

        return (
            <div className="ViewCount">
                <PageText ElementType="span" FontFamily="medium" FontSize="medium-1" Text={t('items_count_viewing')} />
                &nbsp;
                <PageText ElementType="span" FontFamily="semibold" FontSize="medium-1" Text={`${!TotalRecords ? 0 : ((PageNo - 1) * PageSize) + 1} - ${(PageNo * PageSize) < TotalRecords ? (PageNo * PageSize) : TotalRecords}`} />
                &nbsp;
                <PageText ElementType="span" FontFamily="medium" FontSize="medium-1" Text={t('of')} />
                &nbsp;
                <PageText ElementType="span" FontFamily="semibold" FontSize="medium-1" Text={`${TotalRecords} Middle Leaders`} />
            </div>
        )
    }

    render() {
        // var { t } = this.props;

        return (
            <>
                {this.props.TryingDeliverySiteAction && <Loading />}

                {this.renderFilters()}
                {this.renderMiddleLeaders()}

                {this.renderAddMiddleLeaderModal()}
                {this.renderShowMiddleLeaderDetailModal()}
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        Device: state.Window.Device,

        TryingDeliverySiteAction: state.DeliverySite.TryingDeliverySiteAction,
        TryingDeliverySiteActionError: state.DeliverySite.TryingDeliverySiteActionError
    };
};

export default withTranslation()(connect(mapStateToProps, { DeliverySite_GetCompanies_Basic, DeliverySite_GetMiddleLeaderDetails, DeliverySite_GetMiddleLeaders, DeliverySite_GetTopLeaders_Basic, DeliverySite_InsertEditMiddleLeader } )(MiddleLeadersComponent));